// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2ex2V","filesListContainer":"PosDisputesFiles_filesListContainer__-PnRr","filesButton":"PosDisputesFiles_filesButton__3AQNj"};